import React, { useCallback, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Btn, H4 } from '../../../AbstractElements';
import { Link } from 'react-router-dom';

export const columns = [
  {
    name: 'Room name',
    selector: (row) => row['name'],
    sortable: true,
    center: false,
  },
  {
    name: 'Client name',
    selector: (row) => row['client_name'],
    sortable: true,
    center: false,
  },
  {
    name: 'Start date',
    selector: (row) => row['start_date'],
    sortable: true,
    center: false,
  },
  {
    name: 'End date',
    selector: (row) => row['end_date'],
    sortable: true,
    center: false,
  },
  {
    name: 'Room Type',
    selector: (row) => row['room_type'],
    sortable: true,
    center: false,
  },
  {
    name: 'Hotel',
    selector: (row) => row['hotel'],
    sortable: true,
    center: false,
  },
  {
    name: 'Actions',
    selector: (row) => row['actions'],
    sortable: false,
    center: true,
    width: '240px',
  },
];

export const dData = [
  {
    id: 1,
    name: 'Room 1',
    client_name: 'Client 1',
    start_date: '7/8/2023',
    end_date: '27/8/2023',
    room_type: 'Single',
    hotel: 'Hotel 1',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/reservations/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
  {
    id: 2,
    name: 'Room 2',
    client_name: 'Client 2',
    start_date: '7/8/2023',
    end_date: '27/8/2023',
    room_type: 'Dopio',
    hotel: 'Hotel 1',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/reservations/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
  {
    id: 3,
    name: 'Room 3',
    client_name: 'Client 3',
    start_date: '7/8/2023',
    end_date: '27/8/2023',
    room_type: 'Suite',
    hotel: 'Hotel 1',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/reservations/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
];

const ReservationsTable = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelete, setToggleDelete] = useState(false);
  const [data, setData] = useState(dData);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map((r) => r.title)}?`)) {
      setToggleDelete(!toggleDelete);

      setData(
        data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length <= 0)
      );
      setSelectedRows('');
    }
  };
  return (
    <>
      {selectedRows.length !== 0 && (
        <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
          <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data..!</H4>
          <Btn color="danger" onClick={handleDelete}>
            Delete
          </Btn>
        </div>
      )}
      <DataTable
        data={data}
        columns={columns}
        striped={true}
        center={true}
        pagination
        selectableRows
        onSelectedRowsChange={handleRowSelected}
        clearSelectedRows={toggleDelete}
      />
    </>
  );
};
export default ReservationsTable;
